import React from 'react';
import { Box, ButtonBase, IconButton, Typography } from '@mui/material';
import SearchIcon from '@mui/icons-material/Search';
import { useTranslation } from 'react-i18next';

import { useCommandPaletteControls } from './CommandPaletteHost';
import { isMacLike } from './useCommandPalette';

export function shortcutLabel() {
  return isMacLike() ? '⌘K' : 'Ctrl K';
}

/** The small keyboard hint shown next to search fields. */
export function ShortcutHint({ sx }) {
  return (
    <Box
      component="kbd"
      sx={{
        fontFamily: 'inherit',
        fontSize: 11,
        lineHeight: 1,
        px: 0.75,
        py: 0.5,
        borderRadius: '4px',
        border: '1px solid rgba(255,255,255,0.25)',
        color: 'rgba(255,255,255,0.7)',
        whiteSpace: 'nowrap',
        ...sx,
      }}
    >
      {shortcutLabel()}
    </Box>
  );
}

/** Desktop: a field-looking button in the sidebar, styled like OrganizationSelector. */
export function SidebarSearchTrigger() {
  const { t } = useTranslation();
  const { openPalette } = useCommandPaletteControls();
  return (
    <Box sx={{ px: 2, py: 1.5, borderBottom: '1px solid rgba(255,255,255,0.1)' }}>
      <ButtonBase
        onClick={openPalette}
        data-testid="global-search-trigger"
        aria-label={t('commandPalette.openSearch')}
        sx={{
          width: '100%',
          height: 40,
          px: 1.5,
          gap: 1,
          borderRadius: '8px',
          bgcolor: 'rgba(255,255,255,0.1)',
          border: '1px solid rgba(255,255,255,0.2)',
          color: 'rgba(255,255,255,0.75)',
          justifyContent: 'flex-start',
          '&:hover': { bgcolor: 'rgba(255,255,255,0.16)', borderColor: 'rgba(255,255,255,0.3)' },
        }}
      >
        <SearchIcon sx={{ fontSize: 20 }} />
        <Typography
          component="span"
          sx={{ flex: 1, textAlign: 'left', fontSize: 14, overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}
        >
          {t('commandPalette.triggerLabel')}
        </Typography>
        <ShortcutHint />
      </ButtonBase>
    </Box>
  );
}

/** Mobile: an icon button in the AppBar. */
export function MobileSearchTrigger() {
  const { t } = useTranslation();
  const { openPalette } = useCommandPaletteControls();
  return (
    <IconButton color="inherit" onClick={openPalette} aria-label={t('commandPalette.openSearch')} data-testid="global-search-trigger">
      <SearchIcon />
    </IconButton>
  );
}
